module.exports = __webpack_public_path__ + "img/back button.99313b21.svg";